import * as React from 'react';

import {Button} from 'shells/button/button';
import {SaveButton} from 'shells/button/save-button/save-button';

import {FilterSavePopover} from '../../../filtering/filter-save-popover';
import {PageTitleBar} from '../../../layout';

import {useCreateFilter} from './graphql/hooks/use-create-saved-filter';
import {PROSPECTOR_TYPE} from './graphql/hooks/use-get-prospector-saved-filters';
import {useUpdateFilter} from './graphql/hooks/use-update-saved-filter';

type Props = {
    hasChanges: boolean;
    selectedFilterId: string | null | undefined;
    refetch: () => Promise<any>;
};

export function ProspectorPageTitleBar(props: Props) {
    const buttonRef = React.useRef();
    const [isSavePopoverOpen, setIsSavePopoverOpen] = React.useState(false);
    const {createFilter, isLoading, error} = useCreateFilter();
    const [popoverError, setPopoverError] = React.useState(error);
    const {updateFilter, isLoading: isUpdating} = useUpdateFilter();

    // @ts-expect-error
    const handleSave = (name) => {
        createFilter({
            name: name,
            type: PROSPECTOR_TYPE,
            value: window.location.search,
        }).then(() => {
            setIsSavePopoverOpen(false);
            props.refetch();
        });
    };

    return (
        <>
            <PageTitleBar
                title='ProspectorIQ'
                subheaderPrimaryText='Discover new contacts and enhance your outreach with ProspectorIQ’s filtering and search capabilities.'
                buttons={[
                    <Button
                        key='save-as-button'
                        onClick={() => setIsSavePopoverOpen(true)}
                        variant='secondary'
                        size='big'
                        getButtonRef={buttonRef}
                        disabled={!props.hasChanges}
                    >
                        Save as
                    </Button>,
                    <SaveButton
                        isSaving={isUpdating}
                        key='filter-save-button'
                        // @ts-expect-error
                        onClick={() => {
                            if (props.selectedFilterId) {
                                updateFilter({
                                    id: props.selectedFilterId,
                                    value: window.location.search,
                                });
                            }
                        }}
                        buttonText='Save'
                        disabled={!props.hasChanges || !props.selectedFilterId}
                        resetOnComplete={true}
                    />,
                ]}
            />
            {isSavePopoverOpen && (
                <FilterSavePopover
                    errorText={popoverError}
                    onDismissError={() => {
                        setPopoverError(null);
                    }}
                    anchor={buttonRef.current}
                    location='bottom-left'
                    title='Save new filter list as'
                    placeholderText='Name this list'
                    isSaving={isLoading}
                    onSave={handleSave}
                    onClose={() => setIsSavePopoverOpen(false)}
                />
            )}
        </>
    );
}
